export const ROUTES = {
  // Root & Public Pages
  root: "/",
  landing: "/landing",
  about: "/about",

  // Auth
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  resetPassword: "/reset-password",
  verifyAccount: "/verify-account",

  // User Pages
  dashboard: "/dashboard",
  messages: "/messages",
  rooms: "/rooms",
  spectate: "/spectate",
  spectateGuest: "/spectate/guest",
  roomSetup: "/rooms/:id/setup",
  notifications: "/notifications",
  bookmarks: "/bookmarks",
  settings: "/settings",
};
